(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require(undefined));
	else if(typeof define === 'function' && define.amd)
		define(["plesk-ui-library"], factory);
	else if(typeof exports === 'object')
		exports["Jsw"] = factory(require(undefined));
	else
		root["Jsw"] = factory(root[undefined]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 167);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** external {"amd":"plesk-ui-library"} ***!
  \*******************************************/
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 112:
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./app/license-status/LicenseStatus.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var STATUS_DEFAULT = 'default';
var STATUS_TEST = 'test';
var STATUS_TRIAL = 'trial';
var STATUS_EXPIRED = 'expired';

var LicenseStatus = function (_Component) {
    _inherits(LicenseStatus, _Component);

    function LicenseStatus(props) {
        _classCallCheck(this, LicenseStatus);

        var _this = _possibleConstructorReturn(this, (LicenseStatus.__proto__ || Object.getPrototypeOf(LicenseStatus)).call(this, props));

        _this.state = {
            trialOverPopoverVisible: _this.props.daysLeft <= 5 && _this.props.hidePopoverUrl
        };

        _this.handleClosePopover = _this.handleClosePopover.bind(_this);
        return _this;
    }

    _createClass(LicenseStatus, [{
        key: 'handleClosePopover',
        value: function handleClosePopover() {
            this.setState({ trialOverPopoverVisible: false });
            var hidePopoverUrl = this.props.hidePopoverUrl;

            new Ajax.Request(hidePopoverUrl, { method: 'post' });
        }
    }, {
        key: 'renderDaysCounter',
        value: function renderDaysCounter() {
            var _props = this.props,
                status = _props.status,
                daysLeft = _props.daysLeft,
                baseClassName = _props.baseClassName;


            return STATUS_TRIAL === status ? (0, _uiLibrary.createElement)(
                'div',
                { className: baseClassName + '-alert__message-count' },
                daysLeft
            ) : null;
        }
    }, {
        key: 'renderActions',
        value: function renderActions() {
            var _props2 = this.props,
                actionUrl = _props2.actionUrl,
                installUrl = _props2.installUrl,
                status = _props2.status,
                baseClassName = _props2.baseClassName;

            var alertCls = baseClassName + '-alert';

            return actionUrl || installUrl ? (0, _uiLibrary.createElement)(
                'div',
                { className: alertCls + '__actions' },
                actionUrl && (0, _uiLibrary.createElement)(
                    _uiLibrary.Button,
                    {
                        intent: 'primary',
                        component: 'a',
                        icon: 'shopping-cart',
                        className: alertCls + '__actions-button',
                        href: actionUrl,
                        target: '_blank'
                    },
                    (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: status === STATUS_DEFAULT ? 'getTrialButton' : 'buyLicenseButton' })
                ),
                installUrl && (0, _uiLibrary.createElement)(
                    _uiLibrary.Button,
                    {
                        component: 'a',
                        baseClassName: alertCls + '__actions-link',
                        href: installUrl
                    },
                    (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'installLicenseButton' })
                )
            ) : null;
        }
    }, {
        key: 'renderTrialPopover',
        value: function renderTrialPopover(content) {
            var trialOverPopoverVisible = this.state.trialOverPopoverVisible;
            var _props3 = this.props,
                trialOverIcon = _props3.trialOverIcon,
                baseClassName = _props3.baseClassName;

            var popoverCls = baseClassName + '-popover';

            return trialOverPopoverVisible ? (0, _uiLibrary.createElement)(
                _uiLibrary.Popover,
                {
                    className: popoverCls,
                    visible: true,
                    onClose: this.handleClosePopover,
                    target: content
                },
                (0, _uiLibrary.createElement)(
                    _uiLibrary.Item,
                    {
                        title: (0, _uiLibrary.createElement)(
                            'h4',
                            null,
                            (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'trialOverTitle' })
                        ),
                        icon: (0, _uiLibrary.createElement)(_uiLibrary.Icon, { size: 'lg', src: trialOverIcon })
                    },
                    (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: 'trialOverText' })
                )
            ) : content;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props4 = this.props,
                daysLeft = _props4.daysLeft,
                isAdmin = _props4.isAdmin,
                status = _props4.status,
                baseClassName = _props4.baseClassName;
            var trialOverPopoverVisible = this.state.trialOverPopoverVisible;

            var alertCls = baseClassName + '-alert';

            var content = (0, _uiLibrary.createElement)(
                'div',
                { className: (0, _uiLibrary.classNames)(baseClassName, { 'license-status--active': trialOverPopoverVisible }) },
                (0, _uiLibrary.createElement)(
                    _uiLibrary.Alert,
                    {
                        className: alertCls,
                        intent: daysLeft <= 0 ? 'danger' : daysLeft <= 5 ? 'warning' : null
                    },
                    (0, _uiLibrary.createElement)(
                        'div',
                        { className: alertCls + '__inner' },
                        (0, _uiLibrary.createElement)(
                            'div',
                            { className: alertCls + '__message' },
                            this.renderDaysCounter(),
                            (0, _uiLibrary.createElement)(
                                'div',
                                { className: alertCls + '__message-text' },
                                (0, _uiLibrary.createElement)(_uiLibrary.Translate, { content: isAdmin ? status + 'LicenseWarningAdmin' : 'testLicenseWarningClient' })
                            )
                        ),
                        this.renderActions()
                    )
                )
            );

            return this.renderTrialPopover(content);
        }
    }]);

    return LicenseStatus;
}(_uiLibrary.Component);

LicenseStatus.propTypes = {
    status: _uiLibrary.PropTypes.oneOf([STATUS_DEFAULT, STATUS_TEST, STATUS_TRIAL, STATUS_EXPIRED]).isRequired,
    daysLeft: _uiLibrary.PropTypes.number,
    isAdmin: _uiLibrary.PropTypes.bool.isRequired,
    actionUrl: _uiLibrary.PropTypes.string,
    installUrl: _uiLibrary.PropTypes.string,
    hidePopoverUrl: _uiLibrary.PropTypes.string,
    trialOverIcon: _uiLibrary.PropTypes.string,
    baseClassName: _uiLibrary.PropTypes.string
};

LicenseStatus.defaultProps = {
    daysLeft: 0,
    actionUrl: null,
    installUrl: null,
    hidePopoverUrl: null,
    trialOverIcon: null,
    baseClassName: 'license-status'
};

exports.default = LicenseStatus;

/***/ }),

/***/ 167:
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./app/license-status/index.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _uiLibrary = __webpack_require__(/*! @plesk/ui-library */ 0);

var _LicenseStatus = __webpack_require__(/*! ./LicenseStatus */ 112);

var _LicenseStatus2 = _interopRequireDefault(_LicenseStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Copyright 1999-2017. Plesk International GmbH. All rights reserved.

module.exports = function (_ref) {
    var container = _ref.container,
        locale = _ref.locale,
        props = _objectWithoutProperties(_ref, ['container', 'locale']);

    (0, _uiLibrary.render)((0, _uiLibrary.createElement)(
        _uiLibrary.LocaleProvider,
        { messages: locale },
        (0, _uiLibrary.createElement)(_LicenseStatus2.default, props)
    ), container);
};

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// javascript/app/license-status.js